import { render } from "./FooterManagement.vue?vue&type=template&id=58a3e7aa&scoped=true"
import script from "./FooterManagement.vue?vue&type=script&lang=js"
export * from "./FooterManagement.vue?vue&type=script&lang=js"

import "./FooterManagement.vue?vue&type=style&index=0&id=58a3e7aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a3e7aa"]])

export default __exports__